import { AsideMenuHyperLink } from "../../../../layout/components/aside/AsideMenuItem"
import { IPageAction } from "../../../base/models"
import { useGetTouUrl } from "../services/useTouUrl"

export const AsideMenuTOULink = ({ action, hasBullet, className }: {
    action: IPageAction,
    hasBullet: boolean
    className?: string
}) => {
    const { touUrl } = useGetTouUrl()

    if (!touUrl)
        return <></>

    return (
        <AsideMenuHyperLink
            hasBullet={hasBullet}
            className={className}
            to={touUrl}
            materialIcon={action.icon}
            title={action.name}
            fontIcon='bi-app-indicator'
        />)
}